module.exports = __webpack_public_path__ + "img/icon_us.5fd646f5.png";